<template>
  <div>
    <el-form v-model="formData" label-width="100px" size="small">
      <el-row :gutter="10">
        <el-col :span="7">
          <el-form-item
            label-width="130px"
            :label="
              $l('INDEX.form_label_production_order_group_spec_name') ||
                '规格名称'
            "
          >
            <b-form-input
              v-model.trim="formData.groupSpecName"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_group_spec_name') ||
                  '请输入规格名称'
              "
              type="search"
              size="sm"
              clearable
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_fabric_no') || '面料编号'
            "
          >
            <b-form-input
              v-model.trim="formData.fabricNo"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_fabric_no') ||
                  '请输入面料编号'
              "
              type="search"
              size="sm"
              clearable
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_fabric_name') || '面料名称'
            "
          >
            <b-form-input
              v-model.trim="formData.fabricDisplayName"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_fabric_name') ||
                  '请输入面料名称'
              "
              type="search"
              size="sm"
              clearable
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return { formData: {} }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
